export default "__VITE_ASSET__CfWidERU__"